export default "__VITE_ASSET__CtxdScY9__"